import { atom } from 'recoil';

export const aSelectedAttachment = atom<{ addOnId: string; ref: string; description: string } | undefined>({ key: 'aSelectedAttachment', default: undefined });
export const aCurrentRoomId = atom<string | undefined>({ key: 'aCurrentRoomId', default: '' });
export const aCurrentAreaId = atom<string | undefined>({ key: 'aCurrentAreaId', default: '' });
export const aCurrentCampusId = atom<string | undefined>({ key: 'aCurrentCampusId', default: '' });
export const aCurrentOrgId = atom<string | undefined>({ key: 'aCurrentOrgId', default: '' });
export const aIsVisitorAtLandingPage = atom<boolean>({ key: 'aIsVisitorAtLandingPage', default: false });
